import { Component, OnInit, ViewChild, ChangeDetectorRef, Input, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { BeforeEqFilterOperatorComponent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { SVGIcon, fileExcelIcon, pencilIcon, trashIcon, downloadIcon } from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';
import { GridModule } from '@progress/kendo-angular-grid';
import { DatePipe } from '@angular/common';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ExcelExportModule, ExcelExportComponent } from "@progress/kendo-angular-excel-export";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteModalComponent } from 'app/confirm-delete-modal/confirm-delete-modal.component';
import { GridService } from 'app/services/grid.service';
import { SharedService } from 'app/services/shared.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { DataService } from 'app/services/data.service';
import { TranslocoModule, TranslocoPipe } from '@ngneat/transloco';
import { DrakeMatrixEditComponent } from '../drake-matrix-edit/drake-matrix-edit.component';
import { result } from 'lodash';
import { FileService } from 'app/services/file.service';
import { DrakeOption } from 'app/models/interfaces';


@Component({
  selector: 'app-drake-matrix',
  standalone: true,
  providers: [DatePipe],
  imports: [
    CommonModule,
    HttpClientModule,
    GridModule,
    ChartsModule,
    InputsModule,
    ButtonsModule,
    ExcelExportModule,
    MatToolbarModule,
    MatDialogModule,
    TranslocoModule,
    MatIconModule
  ],
  templateUrl: './drake-matrix.component.html',
  styleUrls: ['./drake-matrix.component.scss']
})
export class DrakeMatrixComponent implements OnChanges, AfterViewInit {

  @Input() public fieldConfig: any;
  @Input() viewCode: string;
  @Input() matrixData: Array<any> = [];
  @Input() readonly: boolean;
  public gridColumns: any[] = [];
  public originalOptions: any[];


  public excelSVG: SVGIcon = fileExcelIcon;
  public editSVG: SVGIcon = pencilIcon;
  public deleteSVG: SVGIcon = trashIcon;
  public downloadSVG: SVGIcon = downloadIcon;

  public canEdit: boolean = false;
  public canDelete: boolean = false;
  public canExport: boolean = false;
  public height: number = 500;
  public dropdownOptions: { [key: string]: DrakeOption[] } = {};
  private optionsLoaded: any = {};

  viewConfig: any;
  viewConfigComponent: any;

  @Output() public valueChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private gridService: GridService,
    public dialog: MatDialog,
    private fileService: FileService,
    private router: Router,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private drakeSharedService: DrakeSharedService,
    private dataService: DataService,
    private cdRef: ChangeDetectorRef,) {


  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.viewCode && changes.viewCode.currentValue != changes.viewCode.previousValue || changes.matrixData) {
      this.loadGridConfiguration();
    }
  }

  ngAfterViewInit(): void {
    /*var c = setInterval(() => {

      if (this.fieldConfig.fieldControlType == 'DROPDOWNLIST' && this.originalOptions && this.fieldConfig.drpFilter) {
        this.options = this.originalOptions.filter(item => eval(this.fieldConfig.drpFilter));
      }
    }, 1000);

    if (this.fieldConfig.fieldControlType == 'DROPDOWNLIST') {
      setTimeout(() => {
        this.gridService.getDropDownValues(this.fieldConfig.fieldCode).subscribe(result => {
          this.options = JSON.parse(JSON.stringify(result));
          this.originalOptions = result;
        });
      }, 1000);
    }*/
    //this.cdRef.markForCheck();
  }

  // Map Field
  onChange() {

    console.log('onChange called for', this.fieldConfig.columnCode);
    if (!this.fieldConfig.columnCode) {
      console.error("Field configuration is missing the column code.");
      return;
    }
    const obj = {
      field: this.fieldConfig.columnCode,
      value: this.matrixData[this.fieldConfig.columnCode]
    };
    console.log('Emitting value change:', obj);
    this.valueChanged.emit(obj);




  }

  loadGridConfiguration(): void {
    if (!this.viewCode) {
      return;
    }

    this.gridService.getScopeView(this.viewCode).subscribe(
      (viewConfig: any) => {
        this.viewConfig = viewConfig;
        this.canEdit = viewConfig.canEdit;
        this.canDelete = viewConfig.canDelete;
        this.canExport = viewConfig.canExport;

        this.gridColumns = viewConfig.fields.map((field: any) => {

          let columnDef: any = {
            field: field.columnName,
            title: field.header,
            width: field.size,
            hidden: !field.visible,
            filter: this.getFilterType(field.fieldType, field.fieldControlType),
            sortable: field.sort,
            format: field.format ? `{0:${field.format}}` : undefined,
            cssClass: field.cssClass,
            template: field.template,
            fieldType: field.fieldType,
            fieldControlType: field.fieldControlType,
            fieldControlFormat: field.fieldControlFormat,
            order: field.order,
            group: field.group,

          };
          return columnDef;
        });

        this.getFieldValue();

        this.populateDropdownOptions();
      },
      (error) => {
        console.error('Errore durante il caricamento della configurazione della griglia', error);
      }
    );

    this.gridService.getComponentView(this.viewCode).subscribe(
      (viewConfig: any) => {
        this.viewConfigComponent = viewConfig;
      });
  }

  getFieldValue(): void {

    this.gridColumns.forEach(column => {
      if (column.fieldControlType === 'DROPDOWNLIST') {
        if (!this.drakeSharedService.drpOptions[column.field] && !this.optionsLoaded[column.field]) {
          this.dropdownOptions[column.field] = [] as DrakeOption[];
          this.optionsLoaded[column.field] = true;
          this.dataService.getDropDownOptions(this.viewCode.split(".")[0] + "." + column.field).subscribe((dropdownItems: DrakeOption[]) => {
            dropdownItems.forEach(option => {
              this.dropdownOptions[column.field].push({
                value: option.value,
                text: option.text
              })

            });
            //console.log("Dropdown options Matrix: " + column.field, this.dropdownOptions);

            this.drakeSharedService.drpOptions[column.field] = this.dropdownOptions[column.field];
          });
        }
      }
      else {
        this.dropdownOptions[column.field] = this.drakeSharedService.drpOptions[column.field];
      }

    });

  }



  getFilterType(fieldType: string, fieldControlType: string): string {
    if (fieldControlType === 'DROPDOWNLIST') {
      return 'dropdownlist';
    }
    if (fieldControlType === 'HTML') {
      return 'html';
    }
    if (fieldControlType === 'COLORPICKER') {
      return 'colorPicker';
    }
    if (fieldControlType === 'CODEEDITOR') {
      return 'codeEditor';
    }
    switch (fieldType) {
      case 'TEXTBOX':
      case 'STRING':
        return 'text';
      case 'BOOLEAN':
        return 'dropdownlist';
      case 'NUMBERIC':
      case 'DECIMAL':
      case 'INT':
        return 'numeric';
      case 'DATEPICKER':
      case 'DATETIME':
        return 'date';
      case 'LOCATION':
        return 'location';
      case 'ARRAY':
        return 'array';
      default:
        return 'text';
    }
  }

  populateDropdownOptions(): void {
    this.gridColumns.forEach(column => {
      const options: DrakeOption[] = [];
      const uniqueValues = new Set();
      let hasEmptyOption = false;

      this.matrixData.forEach(item => {
        if (item[column.field]) {
          // Verifica se value e text sono undefined o null e assegna ''
          const value = typeof item[column.field] === 'object' ? item[column.field].value : item[column.field];
          const text = typeof item[column.field] === 'object' ? item[column.field].text : item[column.field];

          if (value === '' && text === '') {
            hasEmptyOption = true;
          }
          if (!uniqueValues.has(value)) {
            uniqueValues.add(value);
            options.push({ value, text });
          }
        }
      });

      if (!hasEmptyOption) {
        options.unshift({ text: '', value: '' });
      }

      this.dropdownOptions[column.field] = options;
    });
  }

  getFileUrl(dataItem: any, field: string): string {
    if (!dataItem[field]?.dataUrl && !dataItem[field]?.isLoading) {
      dataItem[field] = { ...dataItem[field], isLoading: true };
      this.gridService.downloadFile(dataItem[field].id).subscribe({
        next: (urlFile: any) => {
          dataItem[field] = { ...dataItem[field], dataUrl: urlFile.dataUrl, isLoading: false };
        },
        error: () => {
          dataItem[field].isLoading = false;
        }
      });
    }

    return dataItem[field]?.id || '#';
  }

  downloadFile(file: any): void {
    this.fileService.readFileAsBase64String(file.id).subscribe((response: any) => {
      const link = document.createElement('a');
      link.href = `data:${file.contentType};base64,${response.fileContentBase64}`;
      link.download = file.fileName;
      link.click();
    });
  }


  getFileName(dataItem: any, field: string): string {
    return dataItem[field]?.fileName || 'No file available';
  }
  /*
  
    openEdit(item: any | null) {
      const dialogRef = this.dialog.open(DrakeMatrixEditComponent, {
          width: '50%',
          height: '80%',
          data: {
              viewConFilterChangeg: this.viewConfigComponent,
              item: item ? {...item} : {},
              scope: this.viewCode.split('.')[0]
          }
      });
   
      dialogRef.afterClosed().subscribe(result => {
          if (result && result.result) {
              const scope = this.viewCode.split('.')[0];
              const recordId = item ? item._id : Object.keys(result.result[scope])[0];
              const updatedRecord = result.result[scope][recordId];
   
              if (updatedRecord) {
                  if (item) {
                      // Aggiorna l'elemento esistente
                      const index = this.matrixData.findIndex(record => record._id === item._id);
                      if (index > -1) {
                          this.matrixData[index] = {...this.matrixData[index], ...updatedRecord};
                      }
                  } else {
                      // Aggiungi un nuovo elemento
                      this.matrixData.push(updatedRecord);
                  }
                  this.matrixData = [...this.matrixData];
                  this.valueChanged.emit(this.matrixData);
                  this.updateGridData();
              }
          }
      });
  }
  */

  openEdit(item: any | null) {
    const formattedItem = item ? { ...item } : { _id: this.makeid() };

    this.gridColumns.forEach(column => {
      if (column.fieldType === 'DATETIME' && formattedItem[column.field]) {
        formattedItem[column.field] = new Date(formattedItem[column.field]);
      }
      if (column.fieldControlType === 'DROPDOWNLIST' && formattedItem[column.field]) {
        formattedItem[column.field] = formattedItem[column.field].value;
      }
    });

    const dialogRef = this.dialog.open(DrakeMatrixEditComponent, {
      width: '50%',
      height: '80%',
      data: {
        viewConfig: this.viewConfigComponent,
        item: item ? { ...item } : { _id: this.makeid() },
        scope: this.viewCode.split('.')[0],
        header: this.fieldConfig.header
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.result) {
        const scope = this.viewCode.split('.')[0];
        const recordId = item ? item._id : Object.keys(result.result[scope])[0];
        const updatedRecord = result.result[scope][recordId];
        if (updatedRecord) {
          if (item) {
            // Aggiorna l'elemento esistente
            const index = this.matrixData.findIndex(record => record._id === item._id);
            if (index > -1) {
              this.matrixData[index] = { ...this.matrixData[index], ...updatedRecord };
            }
          } else {
            // Aggiungi un nuovo elemento
            this.matrixData.push(updatedRecord);
          }
          this.matrixData = [...this.matrixData];
          this.valueChanged.emit(this.matrixData);
          this.updateGridData();
        }
      }
    });
  }

  getFormattedDate(date: any): string {
    return this.formatDate(date);
  }

  formatDate(value: any): string {
    if (!value) return '';
    const date = new Date(value);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  }

  getTextValue(dataItem: any, column: string): string {
    if (dataItem[column]) {

      if (dataItem[column].text && dataItem[column].value)
        return dataItem[column].text;
      var idFiltered = this.dropdownOptions[column].filter(x => x.value == dataItem[column]);
      if (idFiltered.length > 0)
        return idFiltered[0].text;
      else
        return "";

    }
    return "";

  }

  makeid() {
    //const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    //const charactersLength = 6;
    //let counter = 0;
    var length = 10;

    var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, length);

    /*while (counter < charactersLength) {
      id += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }*/
    return id;
  }

  updateGridData() {
    this.matrixData = [...this.matrixData];
    this.populateDropdownOptions();
    this.cdr.detectChanges();
  }

  deleteActivity(item: any) {
    const dialogRef = this.dialog.open(ConfirmDeleteModalComponent, {
      width: '400px',
      data: { message: 'Are you sure you want to delete this item?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const index = this.matrixData.findIndex(record => record._id === item._id);
        if (index > -1) {
          this.matrixData.splice(index, 1);
          this.matrixData = [...this.matrixData]; // Trigger change detection
          this.valueChanged.emit(this.matrixData); // Emit updated data
          this.cdr.detectChanges(); // Force change detection
        }
      }
    });
  }

}
